import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-6">
          <div className="w-10 h-10 flex items-center justify-center">
            <i className="ri-error-warning-line text-primary-600 text-3xl"></i>
          </div>
        </div>
        <h1 className="font-heading text-4xl font-bold text-foreground-950 mb-2">
          404
        </h1>
        <p className="text-base text-foreground-600 mb-6">
          Oops! The page you are looking for does not exist.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors shadow-sm whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-5-line"></i>
          </div>
          Back to Home
        </Link>
      </div>
    </div>
  );
}